const dateIsValid = date => !!date && date.isValid();

export default dateIsValid;
